/* ================================================================
   Dawn Mobile Drawer – FINAL GUARD
   1. menu-drawer 内の <details> に限り、open を外す操作を封じる
   2. ↗︎ 矢印クリックで自前トグル
   3. 親リンクは遷移だけ行う
   ================================================================ */

/* --- 1. removeAttribute / toggleAttributeガード ------------------- */
(() => {
  const menuDrawer = () => document.getElementById('menu-drawer');

  /* 元メソッドを保存 */
  const _removeAttr  = Element.prototype.removeAttribute;
  const _toggleAttr  = Element.prototype.toggleAttribute;

  /* open を外そうとしたら無視する */
  Element.prototype.removeAttribute = function (name) {
    if (
      name === 'open' &&
      menuDrawer() &&
      menuDrawer().contains(this)
    ) {
      return;                       // ガード：何もせず終了
    }
    return _removeAttr.apply(this, arguments);
  };

  /* toggleAttribute(false) で open を外す場合もガード */
  Element.prototype.toggleAttribute = function (name, force) {
    if (
      name === 'open' &&
      force === false &&
      menuDrawer() &&
      menuDrawer().contains(this)
    ) {
      return this.hasAttribute('open');   // 変化させない
    }
    return _toggleAttr.apply(this, arguments);
  };
})();

/* --- 2. 矢印 (.expand-arrow) で手動トグル ------------------------ */
document.addEventListener('click', (e) => {
  const btn = e.target.closest('.expand-arrow');
  if (!btn) return;

  e.preventDefault();
  e.stopImmediatePropagation();     // 後続 click ハンドラ遮断

  const details = btn.closest('details');
  if (!details) return;

  const isOpen = details.hasAttribute('open');
  if (isOpen) {
    details.removeAttribute('open');
  } else {
    details.setAttribute('open', '');
  }
  btn.setAttribute('aria-expanded', String(!isOpen));
});

/* --- 3. 親リンク (.parent-link) は遷移だけ行い、子メニューは開かせない --- */
document.addEventListener('click', (e) => {
  const link = e.target.closest('.parent-link');
  if (link) e.stopPropagation();
});
